import { Controller } from "@hotwired/stimulus";
import * as common from "@/javascripts/common.js";

// Connects to data-controller="promoters--promoter-staff-settings"
export default class extends Controller {
  static targets = ["deletePath", "deleteEmail", "salesConfirmation", "cancelPostponeRefund"];
  static values = { deleteConfirmation: Boolean };

  connect() {
    // すでに開いてるモーダルがあれば閉じる
    this.closeOpenedModal();
    // 削除確認モーダルを開く
    this.openDeleteConfirmationfModal();
  }

  closeOpenedModal() {
    const openDialog = document.querySelector("dialog.js-modal[open]");
    if (!openDialog) return;

    const modalController = this.application.getControllerForElementAndIdentifier(openDialog, "modal");

    modalController?.close();
  }

  htmlScroll() {
    common.HtmlScroll();
  }

  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "modal",
    );
    modalController.show();
  }

  openDeleteConfirmationfModal() {
    if (this.deleteConfirmationValue) {
      setTimeout(() => {
        const modalController = this.application.getControllerForElementAndIdentifier(this.element, "modal");
        modalController?.show();
      }, 300);
    }
  }

  updateRadioButtons(event) {
    const isAdminAuthorityFull = event.currentTarget.value === "full";
    const targetRadios = [this.salesConfirmationTargets, this.cancelPostponeRefundTargets];

    if (isAdminAuthorityFull) {
      // 管理者権限がfullの場合、falseに変更できないようにする
      targetRadios.forEach((targets) => {
        targets.find((radio) => radio.value === "true").checked = true;
        targets.find((radio) => radio.value === "false").disabled = true;
      });
    } else {
      // 管理者権限がgeneralの場合、falseに変更できるようにする
      targetRadios.forEach((targets) => {
        targets.forEach((radio) => {
          radio.checked = radio.value === "true";
          radio.disabled = false;
        });
      });
    }
  }
}
